import React, { FC, useState } from "react";
import { Button, Modal } from "../../../components/common";
import { NewWalletForm } from "../../forms/wallets";
import { HowToSetupWalletModal } from "./HowToSetupWalletModal";

type Props = {
  isOpen: boolean;
  close: () => void;
  callback: (data?: any) => void;
};

export const NewWalletModal: FC<Props> = ({ isOpen, close, callback }) => {
  const [showHowToSetupWalletModal, setShowHowToSetupWalletModal] =
    useState(false);

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={close}
        title={
          <div className="flex flex-col gap-6">
            <div className="flex gap-6 items-center font-manrope text-base font-semibold">
              <span className="text-violet-300">Dont't have a wallet?</span>

              <Button
                className="!p-0 h-0"
                contentClassName="!p-0 text-blue-500"
                variant={Button.variant.TERTIARY}
                onClick={() => setShowHowToSetupWalletModal(true)}
              >
                Get to know more
              </Button>
            </div>

            <h2>New wallet</h2>
          </div>
        }
        subtitle="Add a crypto wallet for your payments"
      >
        <NewWalletForm callback={callback} />
      </Modal>

      <HowToSetupWalletModal
        isOpen={showHowToSetupWalletModal}
        close={() => setShowHowToSetupWalletModal(false)}
      />
    </>
  );
};
